var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"7","height":"12","viewBox":"0 0 7 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.08398 10.5834L2.07357 6.00004L6.08398 1.41671","stroke":"#828282","stroke-width":"2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }